import { render } from "./portal_side.html?vue&type=template&id=f739cedc&external"
import script from "./portal_side.js?vue&type=script&lang=js&external"
export * from "./portal_side.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__